module.exports = __webpack_public_path__ + "img/PC_02.0ecad908.jpg";